import { GroupId } from '@sr/types';

export function getGroupInfo(groupId: GroupId, numberOfSuggestions: number) {
  return {
    title: getGroupTitle(groupId),
    color: getGroupColor(groupId),
    subtitle: getSubtitle(numberOfSuggestions),
  };
}

export function getGroupColor(groupId: GroupId): string {
  switch (groupId) {
    case 'best-practices':
      return 'rgba(139, 23, 255, 1)';
    case 'completeness':
      return 'rgba(51, 166, 90, 1)';
    case 'correctness':
      return 'rgba(232, 116, 116, 1)';
    case 'formatting':
      return 'rgba(227, 110, 96, 1)';
    case 'impact':
      return 'rgba(86, 174, 255, 1)';
  }
}

function getGroupTitle(groupId: GroupId): string {
  switch (groupId) {
    case 'best-practices':
      return 'Best Practices';
    case 'completeness':
      return 'Completeness';
    case 'correctness':
      return 'Correctness';
    case 'formatting':
      return 'Formatting';
    case 'impact':
      return 'Impact';
  }
}

function getSubtitle(numberOfSuggestions: number): string {
  switch (numberOfSuggestions) {
    case 0:
      return 'Looking good, nice work!';
    case 1:
      return `Getting close, 1 suggestion.`;
    case 2:
      return `Getting close, 2 suggestions.`;
    default:
      return `Needs work, ${numberOfSuggestions} suggestions`;
  }
}

export function getGroupDescription(groupId: GroupId) {
  switch (groupId) {
    case 'best-practices':
      return `These are resume-specific best practices that you should consider to increase your odds of getting an interview. They'll save you hours of Googling and are based on trusted advice from recruiters and hiring managers at top companies.`;
    case 'completeness':
      return `Completeness ensures that you aren't missing things that recruiters expect all resumes to include. Some recruiters will pass on an otherwise good resume if these details are missing.`;
    case 'correctness':
      return ``;
    case 'formatting':
      return `Formatting ensures that your resume is easy to read and free of errors that annoy recruiters and hiring managers. Follow this advice, and your resume will read like a professionally designed document.`;
    case 'impact':
      return `Impact optimizes your resume to stand out. It helps you balance how much to include and how to write clearly and convincingly.`;
  }
}
